/// <reference path="app.hilo.controllers.module.ts" />
/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../apimodel.d.ts" />
/// <reference path="../../common/controllers/screencontrollerbase.ts" />
/// <reference path="hilocontrollerbase.ts" />

module App.HiLO.Controllers {



    'use strict';

    class ReleaseChargeController extends HiLOControllerBase<Hca.HiLO.ViewModel.IReleaseChargeViewModel> {
        public static $inject = ['$injector'];
        public model: Hca.HiLO.ViewModel.IReleaseChargeViewModel;
        public api: Common.Services.ApiService;
        public selectedExclusionValue: string;
        public questionHelperService: App.HiLO.Services.QuestionHelperService;

        private q56 = [
			{ name: 'Current copy of the registered title', description: '', hasUploaded: false, isAdditional: false, isRequired: true, skipped: false },
			{ name: 'Current copy of the title plan', description: '', hasUploaded: false, isAdditional: false, isRequired: true, skipped: false },
			{ name: 'Staircasing obligation document', description: ', a copy of the document which contains the obligation to make a payment to Homes England or one of its <a href="/PredecessorOrganisations" target="_blank">predecessor organisations</a> when a tenant staircases', hasUploaded: false, isAdditional: false, isRequired: true, skipped: false },
			{ name: 'Valuation of the property', description: '(by a RICS surveyor dated within the last 6 months)', hasUploaded: false, isAdditional: false, isRequired: true, skipped: false },
			{ name: 'Populated land registry form', description: 'DS1 or DS3 with plan (as appropriate)', hasUploaded: false, isAdditional: false, isRequired: true, skipped: false, docLink: ['<a href="/Content/DS1.pdf" target="_blank">download DS1 form</a>','<a href="/Content/DS3.pdf" target="_blank">download DS3 form</a>']  },
			{ name: 'Populated land registry form RX4', description: '(with plan if appropriate)', hasUploaded: false, isAdditional: false, isRequired: false, skipped: false, docLink: ['<a href="/Content/RX4.pdf" target="_blank">download RX4 form</a>'] }
        ];//q56
        private q58 = [
			{ name: 'Current copy of the registered title', description: '', hasUploaded: false, isAdditional: false, isRequired: true, skipped: false },
			{ name: 'Current copy of the title plan', description: '', hasUploaded: false, isAdditional: false, isRequired: true, skipped: false },
			{ name: 'A copy of charge or mortgage', description: '', hasUploaded: false, isAdditional: false, isRequired: true, skipped: false },
            { name: 'Confirmation from Link Mortgage Services', description: 'that the charge has not been transferred to them', hasUploaded: false, isAdditional: false, isRequired: true, skipped: false },
			{ name: 'Populated land registry form', description: 'DS1 or DS3 with plan (as appropriate)', hasUploaded: false, isAdditional: false, isRequired: true, skipped: false, docLink: ['<a href="/Content/DS1.pdf" target="_blank">download DS1 form</a>', '<a href="/Content/DS3.pdf" target="_blank">download DS3 form</a>'] },
			{ name: 'Populated land registry form RX4', description: '(with plan if appropriate)', hasUploaded: false, isAdditional: false, isRequired: false, skipped: false, docLink: ['<a href="/Content/RX4.pdf" target="_blank">download RX4 form</a>'] }
        ];//q58
        private q57 = [
			{ name: 'Current copy of the registered title', description: '', hasUploaded: false, isAdditional: false, isRequired: true, skipped: false },
			{ name: 'Current copy of the registered plan', description: '', hasUploaded: false, isAdditional: false, isRequired: true, skipped: false },
			{ name: 'Copy of lease', description: ' which contains the obligations to be complied with on disposal', hasUploaded: false, isAdditional: false, isRequired: true, skipped: false },
			{ name: 'Evidence of compliance', description: '(with obligation to find another keyworker to sell to)', hasUploaded: false, isAdditional: false, isRequired: true, skipped: false },
			{ name: 'Valuation of the property', description: '(by a RICS surveyor dated within the last 6 months)', hasUploaded: false, isAdditional: false, isRequired: true, skipped: false },          
			{ name: 'Confirmation of Keyworker status', description: '(of vendor)', hasUploaded: false, isAdditional: false, isRequired: true, skipped: false },
			{ name: 'Populated land registry form', description: 'DS1 or DS3 with plan (as appropriate)', hasUploaded: false, isAdditional: false, isRequired: true, skipped: false, docLink: ['<a href="/Content/DS1.pdf" target="_blank">download DS1 form</a>', '<a href="/Content/DS3.pdf" target="_blank">download DS3 form</a>'] },
			{ name: 'Populated land registry form RX4', description: '(with plan if appropriate)', hasUploaded: false, isAdditional: false, isRequired: false, skipped: false, docLink: ['<a href="/Content/RX4.pdf" target="_blank">download RX4 form</a>'] }

        ]; // Q57

        private q65 =[
			{ name: 'Current copy of registered title', description: '', hasUploaded: false, isAdditional: false, isRequired: true, skipped: false },
			{ name: 'Current copy of title plan', description: '', hasUploaded: false, isAdditional: false, isRequired: true, skipped: false },
			{ name: 'Copy of the deed', description: '(usually a conveyance or transfer) which imposed the restriction', hasUploaded: false, isAdditional: false, isRequired: true, skipped: false },
			{ name: 'Draft deed of covenant', description: 'required to comply with the restriction', hasUploaded: false, isAdditional: false, isRequired: true, skipped: false }];

        constructor($injector: angular.auto.IInjectorService) {
            super($injector);
            this.model = {
                productName: 'Release mortgage or legal charge',
                contactDetails: {
                    contactAddress: {} as Hca.HiLO.ViewModel.IAddressViewModel
                },
                propertyAddress: {} as Hca.HiLO.ViewModel.IAddressViewModel,
                uploadedFiles: []

            } as Hca.HiLO.ViewModel.IReleaseChargeViewModel;

            this.api = $injector.get<Common.Services.ApiService>('app.common.services.apiService');
            this.title = 'Release mortgage or legal charge - Homes England';
            this.titleSecondary = 'Grant Permission to Sell or Lease Property.';

            this.questionHelperService = $injector.get<App.HiLO.Services.QuestionHelperService>('app.hilo.services.questionHelperService');
            
            this.filesToUpload = this.q57;


            this.questionList = [
                { order: 1, name: 'isuk' },
                { order: 2, name: 'isNotExcluded' },
                { order: 3, name: 'isLandRegistry' }
            ];


            this.currentUpload = this.filesToUpload[0].name;
	        (<any>window).rc = this;
        }

        public beforeInitialize(): angular.IPromise<any> {
            return this.setAuthenticationRequired(false);
        }

        public initialize(): angular.IPromise<any> {

            return this.$q.resolve();
        }

		public isInFuture(value) {
			return value > new Date();
		}

        public updateSection(value: number, formName: string) {
            this.$window.scrollTo(0, 0);
            this.currentFormName = formName;
            if (this.currentSection < 4 && this.currentSection > -1) {
                this.currentSection = value;
            }

        }




        public setDocList()
        {
            if (this.model.hasCapitaConfirmation === true)
            {
                this.filesToUpload = this.q58;
                this.currentUpload = this.filesToUpload[0].name;
                return;
            }

            

            if (this.model.isKeyWorkerOnwardSale)
            {
                this.filesToUpload = this.q57;
                this.currentUpload = this.filesToUpload[0].name;
                return;
            }

            if (this.model.hasCompliedKeyworkerSale)
            {

                this.filesToUpload = this.q57;
                this.currentUpload = this.filesToUpload[0].name;
                return;
            }

            if (this.model.isDispose === true) {

                this.filesToUpload = this.q65;
                this.currentUpload = this.filesToUpload[0].name;
                return;
            }
            
            if (this.model.isKeyWorkerProperty || !this.model.isKeyWorkerProperty) {
                this.filesToUpload = this.q56;
                this.currentUpload = this.filesToUpload[0].name;
                return;
            }
            this.currentUpload = this.filesToUpload[0].name;
        }


        public save(): angular.IPromise<any> {


            this.userMessages.clear();
            this.$window.scrollTo(0, 0);

            this.refNumberService.getReferenceNumber('D').then((data: string) => {
                this.model.referenceNumber = data;

	            this.model.uploadedFiles = _.filter(this.model.uploadedFiles, x => !(<any>x).skipped);

                //  this.model.referenceNumber = ref;
                this.model.formSubmission = JSON.stringify(this.model);

                var postConfig: Common.IApiRequestConfig = {
                    url: 'api/FormSubmission/ReleaseCharge',
                    authenticated: false,
                    data: this.model
                };

                this.busyPromise = this.api.post(postConfig)
                    .then((r: any) => {
                        this.mainForm().$setPristine();
                        this.$state.go('SubmissionComplete', { id: this.model.referenceNumber, product: '2' });
                    });

                return this.$q.resolve();
            });
            return this.$q.resolve();
        }

    }


    angular
        .module('app.hilo.controllers')
        .controller('app.hilo.controllers.releaseChargeController', ReleaseChargeController);

}